export default [
  {
    path: '/customer/list',
    name: '/customerlist',
    meta: {
      title: '风控规则配置'
    },
    component: () => import (/* webpackChunkName: "customer-riskr" */ '../views/customerRisk/list.vue')
  },
  {
    path: '/customer/businesslist',
    name: '/businesslist',
    meta: {
      title: '风控业务配置'
    },
    component: () => import (/* webpackChunkName: "customer-riskr" */ '../views/customerRisk/businesslist.vue')
  },
  {
    path: '/customer/ruleConfig',
    name: '/ruleConfig',
    meta: {
      title: '规则配置'
    },
    component: () => import (/* webpackChunkName: "customer-riskr" */ '../views/customerRisk/ruleConfig.vue')
  },
  {
    path: '/customer/pushLog',
    name: '/pushLog',
    meta: {
      title: '推送日志配置'
    },
    component: () => import (/* webpackChunkName: "customer-riskr" */ '../views/customerRisk/pushLog.vue')
  }
]
